import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, PhoneIcon, NavigationIcon } from 'lucide-react';
export function LocationMap() {
  return <section className="py-20 px-4 bg-brand-dark text-white pt-[50px] pb-[50px]" data-id="element-74" data-mp="16y86dxqpa70m">
      <div className="max-w-6xl mx-auto" data-id="element-75" data-mp="170b83f17tol6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-76" data-mp="1az1tiowbjhsg">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-77" data-mp="1tyfrdhx65co8">
            Visit us
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold" data-id="element-78" data-mp="2hngtknferrl2">
            Find our auto shop in St. Paul
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch" data-id="element-79" data-mp="21xxglvu94wzs">
          {/* Map */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="lg:col-span-3 rounded-2xl overflow-hidden shadow-2xl shadow-black/30 border border-gray-700 min-h-[320px]" data-id="element-80" data-mp="1wyubkbe9uqrt">
            <iframe title="Lancer Service location — 270 E 8th St, St Paul, MN 55101" src="https://www.google.com/maps?q=270+E+8th+St,+St+Paul,+MN+55101&output=embed" width="100%" height="100%" style={{
            border: 0,
            minHeight: '320px'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-81" data-mp="2uk8kbfd5ne0t" />
          </motion.div>

          {/* Location details */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.25
        }} className="lg:col-span-2 flex flex-col justify-center gap-8" data-id="element-82" data-mp="34bd69mnu9ld2">
            <div className="flex items-start gap-4" data-id="element-83" data-mp="3o0f9h9vdj30i">
              <div className="w-12 h-12 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-84" data-mp="3o1qe1bwn8eso">
                <MapPinIcon className="w-6 h-6 text-brand-accent" data-id="element-85" data-mp="v6f2fmm1gl6" />
              </div>
              <div data-id="element-86" data-mp="5tr73rrpktyj">
                <h3 className="font-heading uppercase tracking-wide font-bold text-lg mb-1" data-id="element-87" data-mp="5sy5t6biqwns">
                  Address
                </h3>
                <a href="https://google.com/maps?um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KbmDlI9Q1feHMfLJfRWdix_1&daddr=270+E+8th+St,+St+Paul,+MN+55101" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-accent transition-colors text-lg leading-relaxed" data-id="element-88" data-mp="fyzfto7ehuox">
                  270 E 8th St, St Paul, MN 55101
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-89" data-mp="tqdx9qlntntv">
              <div className="w-12 h-12 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-90" data-mp="oycncbbys970">
                <ClockIcon className="w-6 h-6 text-brand-accent" data-id="element-91" data-mp="kxkgtpuh8ief" />
              </div>
              <div data-id="element-92" data-mp="1hef4mw73qy7p">
                <h3 className="font-heading uppercase tracking-wide font-bold text-lg mb-1" data-id="element-93" data-mp="1hexamkjkgqst">
                  Hours
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-94" data-mp="1cmnicxuzbend">
                  Monday – Friday
                  <br data-id="element-95" data-mp="x80eeo8iwe4q" />
                  7:00 am – 5:00 pm
                </p>
                <p className="text-gray-500 text-sm mt-1" data-id="element-96" data-mp="126lcoi47snqj">
                  Closed Saturday & Sunday
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-97" data-mp="s6b111xtvodh">
              <div className="w-12 h-12 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-98" data-mp="s747e1svkbv3">
                <PhoneIcon className="w-6 h-6 text-brand-accent" data-id="element-99" data-mp="1kvi9asn33sbx" />
              </div>
              <div data-id="element-100" data-mp="1kxm84w64m15c">
                <h3 className="font-heading uppercase tracking-wide font-bold text-lg mb-1" data-id="element-101" data-mp="1743gxv7aees7">
                  Phone
                </h3>
                <a href="tel:6512240267" className="text-gray-300 hover:text-brand-accent transition-colors text-lg font-medium" data-id="element-102" data-mp="1b4ncwvg4jccr">
                  (651) 224-0267
                </a>
              </div>
            </div>

            <a href="https://www.google.com/maps/dir/?api=1&destination=270+E+8th+St,+St+Paul,+MN+55101" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-md transition-colors shadow-lg shadow-brand-accent/20 mt-2" data-id="element-103" data-mp="3obwnkbrmtgwf">
              <NavigationIcon className="w-5 h-5" data-id="element-104" data-mp="35elpuvlnevj3" />
              Get Directions
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}